// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__uk5Dz","bottom":"styles_bottom__N6T6u"};